/** Suma días a una fecha YYYY-MM-DD, sin desplazamientos por zona horaria. */
export const adelantarFecha = (fecha: string, dias: number): string => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    throw new Error('La fecha debe tener el formato YYYY-MM-DD');
  }

  const date = new Date(`${fecha}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== fecha) {
    throw new Error('La fecha no es válida');
  }
  if (!Number.isSafeInteger(dias)) {
    throw new Error('La cantidad de días debe ser un número entero');
  }

  date.setUTCDate(date.getUTCDate() + dias);
  if (Number.isNaN(date.getTime()) || date.getUTCFullYear() < 0 || date.getUTCFullYear() > 9999) {
    throw new Error('La fecha resultante está fuera del rango permitido');
  }
  return date.toISOString().slice(0, 10);
};

export const formatSmartDateTime = (dateValue: string | Date) => {
  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  const now = new Date();

  const isSameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - now.getDay());
  startOfWeek.setHours(0, 0, 0, 0);

  const isSameWeek = date >= startOfWeek && date <= now;

  const time = new Intl.DateTimeFormat('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);

  if (isSameDay) {
    return time;
  }

  if (isYesterday) {
    return `Ayer ${time}`;
  }

  if (isSameWeek) {
    return new Intl.DateTimeFormat('es-AR', {
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  return new Intl.DateTimeFormat('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};
